/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2024-11-21 21:10:06
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React from "react";
import { BsyUtils } from "../../utils/Utils";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsyTextArea extends BsyWidget {
  constructor(props) {
    super({
      waterMark: "",
      autoHeight: false,
      baseCls: "bsy-textarea",
      inputCls: "x-textarea",
      width: 734,
      height: 140,
      ...props,
    });
    this.state = {
      value: this.options.value,
      autoHeight: props.autoHeight,
    };
    this.height = props.height;
    this.input = React.createRef();
    this.element = React.createRef();
    this.handleChange = this.handleChange.bind(this);
  }

  _init = () => {
    this.setHeight();
  };
  getValue = () => {
    return this.value;
  };

  getText = () => {
    return this.getValue();
  };

  // UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
  //   //防止多次重复 setState
  //   let props = {};
  //   if (nextProps.value !== this.state.value) {
  //     if (BsyUtils.isObjectEmpty(nextProps.value)) {
  //       props.value = "";
  //     } else {
  //       props.value = nextProps.value;
  //     }
  //     this.value = props.value;
  //   }

  //   if (!BsyUtils.isObjectEmpty(props)) {
  //     this.setState(
  //       {
  //         ...props,
  //       },
  //       () => {
  //         this.value = props.value;
  //       }
  //     );
  //   }
  // }

  handleChange(event) {
    this.value = event.target.value;
    this.setState({ value: this.value }, () => {
      this.setHeight();
      BsyUtils.applyFunc(
        this,
        this.options.onAfterEdit,
        [this.value ? this.value : "", null, this],
        !1
      );
    });
  }
  onFocus = (e) => {
    // x-input-focus
    this.hasFocus = true;
    e.target.classList.add("x-input-focus");
    this.lastValue = e.target.value;
  };
  onBlur = (e) => {
    e.target.classList.remove("x-input-focus");
    this.hasFocus = false;
    this.value = e.target.value.trim();
    this.setState({ value: this.value }, () => {
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value ? this.value.trim() : "", null, this],
        !1
      );
    });
  };

  setHeight = () => {
    const { autoHeight, height } = this.options;
    if (this.input.current) {
      if (autoHeight) {
        this.input.current.style.height = "auto";
        let max = Math.max(this.input.current.scrollHeight, height);
        this.height = max;
        this.input.current.style.height = `${max}px`;
        this.input.current.style.overflow = "hidden";
      }
    }
  };

  setTextState = (a) => {
    let b = this.options;
    // c = b.inputCls + "-error " + b.inputCls + "-success " + b.inputCls + "-warning";
    b.state = a;
    if (!this.input || !this.input.current) {
      return;
    }
    switch (a) {
      case BsyConfig().States.SUCCESS:
        this.input.current.classList.add(b.inputCls + "-success");
        break;
      case BsyConfig().States.ERROR:
        this.input.current.classList.add(b.inputCls + "-error");
        break;
      case BsyConfig().States.WARNING:
        this.input.current.classList.add(b.inputCls + "-warning");
        break;
      default:
        this.input.current.classList.remove(b.inputCls + "-success");
        this.input.current.classList.remove(b.inputCls + "-error");
        this.input.current.classList.remove(b.inputCls + "-warning");
        break;
    }
  };
  getTextState = () => {
    return this.options.state ? 0 : this.options.state;
  };
  checkValidate = () => {
    var a = this.options,
      b = this.value,
      c = !0;

    if (BsyUtils.isEmpty(b)) {
      c = a.allowBlank;
      if (!c) {
        this.setInvalidateTypeText(React.language("item.required"));
      }
    }
    return (
      c
        ? BsyUtils.applyFunc(this, a.onValidateSuccess, [b], !1) === !1 &&
        this.setTextState(BsyConfig().States.NORMAL)
        : BsyUtils.applyFunc(this, a.onValidateFail, [b], !1) === !1 &&
        this.setTextState(BsyConfig().States.ERROR),
      BsyUtils.applyFunc(this, a.onAfterValidate, [b, c], !1),
      c
    );
  };

  setValue = (v) => {
    const { autoHeight } = this.options;

    v = BsyUtils.toStringDetailed(v);
    this.value = BsyUtils.getAddressText(v);


    this.setState(
      {
        value: this.value,
      },
      () => {
        if (autoHeight) {
          this.setHeight();
        }
        BsyUtils.applyFunc(this, this.options.onStickyStopEdit, [], !1);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (nextProps.value !== this.state.value) {
      props.value = nextProps.value;
      this.value = props.value;
    }

    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState(
        {
          ...props,
        },
        () => {
          this.value = props.value;
        }
      );
    }
  }

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value ? this.value.trim() : "", null, this],
        !1
      );
    }
  }

  renderDisablePane = (value) => {
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
      >
        {value ? <pre>{value}</pre> : ""}
      </div>
    );
  };

  render() {
    const {
      cssName,
      inputCls,
      widgetName,
      waterMark,
      hint,
      autoHeight,
    } = this.options;
    const { value } = this.state;
    let css = {
      width: this.options.width,
    };

    if (!this.isEnabled()) {
      return this.renderDisablePane(value);
    }

    return (
      <div className={cssName} style={css} ref={this.element}>
        <textarea
          style={{
            // minHeight: this.height,
            width: "100%",
            resize: "none",
            height: this.height,
            overflow: autoHeight ? "hidden" : "",
          }}
          rows={1}
          className={inputCls}
          ref={this.input}
          widgetname={widgetName}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.handleChange}
          onKeyUp={this.onKeyUp}
          placeholder={waterMark || hint ? waterMark || hint : ""}
          value={value || ""}
        ></textarea>
      </div>
    );
  }
}
